import { render } from "./LabelEditModal.vue?vue&type=template&id=0a393d6e&scoped=true"
import script from "./LabelEditModal.vue?vue&type=script&lang=js"
export * from "./LabelEditModal.vue?vue&type=script&lang=js"

import "./LabelEditModal.vue?vue&type=style&index=0&id=0a393d6e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a393d6e"]])

export default __exports__